(($, duo) => {
  Drupal.behaviors.faq= {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {

      /* setup faq */
      /* ********* */

      const faqList = '.paragraph__faq__list';
      const faqItem = '.paragraph__faq__list__item';

      const faqItemBtn = '.js-faq-toggle';
      const faqItemText = '.js-faq-text';

      // Set all the items text on hidden (so if there is no JS all the items will be visible)
      $(faqItemBtn).attr('aria-expanded', false);
      $(faqItemText).attr('aria-hidden', true);

      // Set all the aria-controls
      $($(faqItem)).each(function(){
        let id = duo.Utils.uniqueId;

        $(this).find(faqItemBtn).attr('aria-controls', id);
        $(this).find(faqItemText).attr('id', id);
      });

      $(document).on( 'click', faqItemBtn, function() {

        if($(this).attr('aria-expanded') === 'false') {

          // Close all other faq items
          $($(this).parents(faqList).find(faqItem)).each(function(){
            if($(this).find(faqItemBtn).attr('aria-expanded') === 'true') {
              $(this).find(faqItemBtn).attr('aria-expanded', false);
              $(this).find(faqItemBtn).parent().find(faqItemText).attr('aria-hidden', true);

              $(this).find(faqItemBtn).parent().find(faqItemText).stop().slideToggle();
            }
          });

          $(this).attr('aria-expanded', true);
          $(this).parent().find(faqItemText).attr('aria-hidden', false);

        } else {
          $(this).attr('aria-expanded', false);
          $(this).parent().find(faqItemText).attr('aria-hidden', true);
        }

        // Open the selected faq item
        $(this).parent().find(faqItemText).stop().slideToggle();

      });

      
    },

  };
})(jQuery, window.duo = window.duo || {});
